<template>
	<button
		tabindex="-1"
		class="itv-btn-clear"
		@click.prevent="$emit('clickEvent')"
	>
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M3.20921 3.20921C3.48816 2.93026 3.94042 2.93026 4.21936 3.20921L8 6.98985L11.7806 3.20921C12.0596 2.93026 12.5118 2.93026 12.7908 3.20921C13.0697 3.48816 13.0697 3.94042 12.7908 4.21936L9.01015 8L12.7908 11.7806C13.0697 12.0596 13.0697 12.5118 12.7908 12.7908C12.5118 13.0697 12.0596 13.0697 11.7806 12.7908L8 9.01015L4.21936 12.7908C3.94042 13.0697 3.48816 13.0697 3.20921 12.7908C2.93026 12.5118 2.93026 12.0596 3.20921 11.7806L6.98985 8L3.20921 4.21936C2.93026 3.94042 2.93026 3.48816 3.20921 3.20921Z"
				fill="#252628"
			/>
		</svg>
	</button>
</template>

<script>
export default {
	name: 'BtnClear',
}
</script>
